import { FC } from "react";

import __ from "web/Layout/Translations";

import { getValueByType } from "web/utils/page/product/subscription/forms/prepareFormData";

import formLabels from "web/constants/formLabels";

import {
  FormType,
  FormView,
  ISubscriptionFormData,
  ISubscriptionFormMode,
  ISubscriptionReceiverFormField,
  SubscriptionFormFieldType,
} from "web/types/Subscription";

import FieldPreviewMUI from "./FieldPreview/fieldPreviewMUI";

interface ISubscriptionReceiverDataPreviewProps {
  fields: ISubscriptionReceiverFormField[];
  formType: FormType;
  formData: ISubscriptionFormData;
  mode: ISubscriptionFormMode;
  viewType: string;
}

const SubscriptionReceiverDataPreviewMUI: FC<
  ISubscriptionReceiverDataPreviewProps
> = ({ fields, formType, formData, mode, viewType }) => {
  return (
    <>
      {/* Small form should preview whole data - get form structure from fields & match them in values */}
      {formType === FormType.FORM &&
        fields.map((field) => (
          <FieldPreviewMUI
            key={field.id}
            id={field.id}
            label={field.label}
            value={formData.fields[field.id] as string}
            showRedValue={
              mode.awaitsUpdate && viewType === FormView.MY_SUBSCRIPTIONS
            }
          />
        ))}

      {/* Active Form should preview only firstname & lastname, in case of external forms also email */}
      {formType === FormType.ACTIVE_FORM && (
        <>
          {mode.externalForm && (
            <FieldPreviewMUI
              label={__(formLabels.email)}
              value={formData.fields.receiverEmail as string}
              showRedValue={
                mode.awaitsUpdate && viewType === FormView.MY_SUBSCRIPTIONS
              }
            />
          )}
          <FieldPreviewMUI
            label={__(formLabels.firstname)}
            value={
              getValueByType(
                fields,
                formData,
                SubscriptionFormFieldType.FIRSTNAME
              ) as string
            }
            showRedValue={
              mode.awaitsUpdate && viewType === FormView.MY_SUBSCRIPTIONS
            }
          />
          <FieldPreviewMUI
            label={__(formLabels.lastname)}
            value={
              getValueByType(
                fields,
                formData,
                SubscriptionFormFieldType.LASTNAME
              ) as string
            }
            showRedValue={
              mode.awaitsUpdate && viewType === FormView.MY_SUBSCRIPTIONS
            }
          />
        </>
      )}
    </>
  );
};

export default SubscriptionReceiverDataPreviewMUI;
